import { Button, Text } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useCopyAndNotify } from '../../hooks/useCopyAndNotify'
import * as Styled from './styles'
import { CopyableProps } from './types'
import { isButtonProps } from './utils/isButtonProps'

export const Copyable = (props: CopyableProps): ReactElement => {
  const { children, valueToCopy } = props
  const { t } = useTranslation()
  const { copy } = useCopyAndNotify()

  const onIconClick = useCallback(() => {
    copy(valueToCopy)
  }, [copy, valueToCopy])

  if (isButtonProps(props)) {
    const { renderAs, ...buttonProps } = props

    return (
      <Styled.Tooltip as="span" label={t('copyable.tooltip')}>
        <Button icon="copy" onClick={onIconClick} variant="text" {...buttonProps}>
          {children}
        </Button>
      </Styled.Tooltip>
    )
  }

  const { renderAs, ...textProps } = props

  return (
    <Styled.Tooltip as="span" label={t('copyable.tooltip')}>
      <Text onClick={onIconClick} {...textProps}>
        {children}
      </Text>
    </Styled.Tooltip>
  )
}
